/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import { useUtils } from '../../core/hooks/useUtils';
import { MODAL_TYPES, useGlobalModalContext } from '../../shared/global-modal';
import { getSnapsAction } from '../../store/Snaps/action';

export type ITab = 'Created by me' | 'Shared with me';
interface IOutput {
	state: HookState;
	isLoading: boolean;
	isLoaded: boolean;
	page?: number;
	totalPages?: number;
	data: any;
	toggleSearch(): void;
}

interface HookState {
	isLoading: boolean;
	isScrolled: boolean;
}

export default function useHook(): IOutput {
	const { showModal } = useGlobalModalContext();

	const {
		dispatch,
		store: { snaps },
	} = useUtils();

	const [state, setState] = useState<HookState>({
		isLoading: true,
		isScrolled: false,
	});

	useEffect(() => {
		window.addEventListener('scroll', handleResize);
		dispatch(getSnapsAction({ page: 1}));
		return () => window.removeEventListener('scroll', handleResize);
	}, []);

	const handleResize = () => {
		setState(prev => ({ ...prev, isScrolled: window.pageYOffset > 0 }));
	};

	const toggleSearch = () => {
		const container = document.getElementById('search');
		const rect = container!.getBoundingClientRect();
		const { height, left, top, width } = rect;
		showModal(MODAL_TYPES.ASK_MODAL, {
			title: 'We have sent you a csv file with this report data',
			styles: {
				content: {
					marginTop: top,
					marginLeft: left,
					height,
					width,
				},
			},
		});
	};

	return {
		state,
		isLoading: snaps.isLoading,
		isLoaded: snaps.isLoaded,
		page: snaps.data.page,
		totalPages: snaps.data.totalPages,
		data: snaps.data.itemsList,
		toggleSearch,
	};
}
